import React from 'react';
import './Header.css';
import Countdown from 'react-countdown';
import { Link } from 'gatsby';
import { countdownPromoText } from '../../utils';

// Timer display component - formats and displays countdown values
const Timer = ({ days, hours, minutes, seconds }) => {
    const numberFormatter = new Intl.NumberFormat('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });
    days = numberFormatter.format(days);
    hours = numberFormatter.format(hours);
    minutes = numberFormatter.format(minutes);
    seconds = numberFormatter.format(seconds);

    return (
        <div className="row justify-content-center gx-4 gx-md-5 black-friday-timer">
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`P${days}D`}>
                    {days}
                </time>
                <span className="d-block timer-label">Days</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${hours}H`}>
                    {hours}
                </time>
                <span className="d-block timer-label">Hrs</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${minutes}M`}>
                    {minutes}
                </time>
                <span className="d-block timer-label">Min</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${seconds}S`}>
                    {seconds}
                </time>
                <span className="d-block timer-label">Sec</span>
            </div>
        </div>
    );
};

function CountdownBanner({ endDate }) {
    return (
        <Link to="/specials/" aria-label="View special offers and promotions">
            <section
                id="black-friday-countdown"
                className="d-flex align-items-center justify-content-center flex-column text-center py-3"
            >
                <span className="countdown-text pb-2 text-sm">{countdownPromoText}</span>
                <Countdown date={endDate} renderer={Timer} />
            </section>
        </Link>
    );
}

export default CountdownBanner;
